import React from 'react';

const Chat = () => <div>Chat</div>;

export default Chat;
